import { useState } from "react";
import type { FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBarProps {
  initialValue?: string;
  placeholder?: string;
  variant?: "header" | "page";
  className?: string;
  autoFocus?: boolean;
}

export default function SearchBar({
  initialValue = "",
  placeholder = "搜索剧名、演员或题材",
  variant = "page",
  className = "",
  autoFocus = false,
}: SearchBarProps) {
  const [keyword, setKeyword] = useState(initialValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    navigate(`/search?q=${encodeURIComponent(kw)}`);
  };

  const isHeader = variant === "header";

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={`flex items-center gap-2 rounded-full border pl-4 pr-1 py-1 transition-colors ${
        isHeader
          ? "border-background-50/25 bg-background-50/10 focus-within:border-accent-400/70"
          : "border-background-300 bg-background-50 focus-within:border-primary-400"
      } ${className}`}
    >
      <div className="w-4 h-4 flex items-center justify-center shrink-0">
        <i
          className={`ri-search-line text-sm ${
            isHeader ? "text-background-200" : "text-foreground-400"
          }`}
          aria-hidden="true"
        />
      </div>
      <input
        type="search"
        name="q"
        value={keyword}
        autoFocus={autoFocus}
        onChange={(event) => setKeyword(event.target.value)}
        placeholder={placeholder}
        aria-label="搜索电视剧"
        className={`flex-1 min-w-0 bg-transparent outline-none text-sm ${
          isHeader
            ? "text-background-50 placeholder:text-background-300"
            : "text-foreground-900 placeholder:text-foreground-400"
        }`}
      />
      <button
        type="submit"
        className={`shrink-0 rounded-full px-4 py-1.5 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
          isHeader
            ? "bg-accent-500 text-primary-950 hover:bg-accent-400"
            : "bg-primary-500 text-background-50 hover:bg-primary-600"
        }`}
      >
        搜索
      </button>
    </form>
  );
}